import { IconButton, InputAdornment, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import GenerateIcon from '../GenerateIcon'
import { IBaseDynamicFormElement } from '../Form/DynamicForm'
import ScanQRCode from '../../features/items/ScanQRCode'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'
import { IStrongPasswordResponse, verifyStrongPassword } from '../../features/user/UsersApp'
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

export default function TextFieldElement2(props: IBaseDynamicFormElement) {

    const { id, label, fullWidth, handleOnChange, data, multiline, maxRows, minRows, handleKeyUp, enableQrCodeScanner, validateInput, placeholder, enableStrongPassword, endAdornment } = props

    const dispatch = useDispatch()

    const [fieldType, setFieldType] = useState<string>(props.fieldType ? props.fieldType : "text")
    const [showQrCodeScanner, setShowQrCodeScanner] = useState<boolean>(false)

    const [strongPasswordResponse, setStrongPasswordResponse] = useState<IStrongPasswordResponse>({
        lowercase: false,
        uppercase: false,
        numbers: false,
        special_character: false,
        length: false,
        valid: false
    })

    let inputProps = {}

    if (props.fieldType === "password"){
        inputProps = {
            endAdornment: <InputAdornment position="end"><IconButton onMouseUp={() => setFieldType("password")} onMouseDown={() => setFieldType("text")}><GenerateIcon icon={fieldType === "password" ? "show" : "hide"} /></IconButton></InputAdornment>
        }
    }

    if (props.fieldType === "search"){
        inputProps = {
            startAdornment: <InputAdornment position="start"><IconButton><GenerateIcon icon="search" /></IconButton></InputAdornment>
        }
    }

    if (enableQrCodeScanner){
        inputProps = {
            endAdornment: <InputAdornment position="end"><IconButton onClick={() => setShowQrCodeScanner(true)}><GenerateIcon icon="qrcode" /></IconButton></InputAdornment>
        }
    }

    if (endAdornment){
        inputProps = {
            endAdornment: endAdornment
        }
    }

    const handleScannedQrCode = (result: string) => {

        if (validateInput){
            if (validateInput(result)){
                handleOnChange(id, result)
            }else{
                handleRequestError({ response: { data: { message: "Invalid format" } } }, dispatch)
            }
        }else{
            handleOnChange(id, result)
        }

    }

    /**
     * Render password verify
     */
    const renderPasswordVerify = () => {

        interface IPasswordVerifyItem {
            title: string,
            checked: boolean
        }

        if (fieldType !== "password"){
            return <></>
        }

        if (!enableStrongPassword){
            return <></>
        }

        let items: Array<IPasswordVerifyItem> = [
            {
                title: "Includes lowercase",
                checked: strongPasswordResponse.lowercase
            },
            {
                title: "Includes uppercase",
                checked: strongPasswordResponse.uppercase
            },
            {
                title: "Includes numbers",
                checked: strongPasswordResponse.numbers
            },
            {
                title: "Includes symbols",
                checked: strongPasswordResponse.special_character
            },
            {
                title: "Minimum length is 8 characters",
                checked: strongPasswordResponse.length
            }
        ]

        return(
            <div className="verify-strong-password-container">
                <div className="content-of-verify-strong-password-container">
                    {items.map((item, index) => {

                        return(
                            <div key={index} className={item.checked ? "item-of-verify-strong-password-container checked" : "item-of-verify-strong-password-container"}>
                                <div className="content-of-item-of-verify-strong-password-container">

                                    <div className="icon-of-item-of-verify-strong-password-container">
                                        <div className="content-of-icon-of-item-of-verify-strong-password-container">
                                            {item.checked ? <CheckIcon /> : <CloseIcon />}
                                        </div>
                                    </div>

                                    <div className="text-of-item-of-verify-strong-password-container">
                                        <div className="content-of-text-of-item-of-verify-strong-password-container">
                                            <p>{item.title}</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        )
                    })}
                </div>  
            </div>
        )
    }

    const onChange = (id: string, value: any) => {

        if (enableStrongPassword){
            if (fieldType == "password"){
                setStrongPasswordResponse(verifyStrongPassword(value))
            }
        }

        handleOnChange(id, value)
    }

    return(
        <>
            {enableQrCodeScanner && <ScanQRCode shown={showQrCodeScanner} handleDecodedText={handleScannedQrCode} handleClose={() => setShowQrCodeScanner(false)} />}
            <TextField 
                    id={id} 
                    error={data.helperTextType == "error" ? true : false} 
                    type={fieldType} 
                    label={label} 
                    placeholder={placeholder}
                    variant="outlined" 
                    fullWidth={fullWidth} 
                    value={data.value} 
                    onChange={(e) => onChange(id, e.target.value)} 
                    InputProps={inputProps} 
                    multiline={multiline}
                    maxRows={maxRows}
                    minRows={minRows}
                    onKeyUp={(e: React.KeyboardEvent<HTMLDivElement>) => {
                        if (handleKeyUp){
                            handleKeyUp(e)
                        }
                    }}        
            />
            {data.value && renderPasswordVerify()}
        </>
    )
}